export function initChangePasswordForm() : void {
    const $changePasswordForms = document.querySelectorAll<HTMLFormElement>('.js-change-password-form');

    $changePasswordForms.forEach($changePasswordForm => {
        new ChangePasswordForm($changePasswordForm);
    });
}

/**
 * @property {HTMLElement}            $form                The form Element
 * @property {NodeList.<HTMLElement>} $formErrors          The form error Elements
 * @property {HTMLElement}            $passwordInput       The password field Element
 * @property {Object}                 validationIndicators The validation indicators
 * @property {RegExp}                 lowercaseRegex       The regex for lowercase verification
 * @property {RegExp}                 uppercaseRegex       The regex for uppercase verification
 * @property {RegExp}                 numberRegex          The regex for number verification
 * @property {RegExp}                 specialRegex         The regex for special char verification
 */
class ChangePasswordForm {
    $form: HTMLFormElement;
    $formErrors: NodeListOf<HTMLLIElement>;

    $passwordInput: HTMLInputElement;
    validationIndicators: { [key: string]: HTMLElement };

    lowercaseRegex = /([a-z]{1,})/;
    uppercaseRegex = /([A-Z]{1,})/;
    numberRegex = /([0-9]{1,})/;
    specialRegex = /([\W]{1,})/;

    constructor($form: HTMLFormElement) {
        this.$form = $form;
        this.$formErrors = this.$form.children[0].querySelectorAll<HTMLLIElement>('li');

        this.$formErrors.forEach($error => {
            if (['length', 'lowercase', 'uppercase', 'number', 'special'].includes($error.innerText)) {
                $error.remove();
            }
        });

        this.$passwordInput = $form.querySelector('.password-field') as HTMLInputElement;
        this.validationIndicators = {};

        const $validationIndicators = $form.querySelectorAll<HTMLElement>('[data-validation-indicator]');
        $validationIndicators.forEach(($indicator, index) => {
            const indicatorName = $indicator.getAttribute('data-validation-indicator') || index;
            this.validationIndicators[indicatorName] = $indicator;
        });

        this.addFormEvents();
    }

    /**
     * Add events on form fields
     * 
     * @return {void}
     */
    addFormEvents() : void {
        const validateInput = () => {
            this.validateInputHandler();
        };

        this.$passwordInput.addEventListener('keyup', validateInput);
        this.$passwordInput.addEventListener('blur', validateInput);
    }

    /**
     * @return {void}
     */
    validateInputHandler() : void {
        const value = this.$passwordInput.value;
        const minLength = parseInt(this.$passwordInput.dataset.minLength || '0');

        if (minLength <= value.length) {
            this.validate('length');
        } else {
            this.unvalidate('length');
        }

        if (this.lowercaseRegex.test(value)) {
            this.validate('lowercase');
        } else {
            this.unvalidate('lowercase');
        }

        if (this.uppercaseRegex.test(value)) {
            this.validate('uppercase');
        } else {
            this.unvalidate('uppercase');
        }

        if (this.numberRegex.test(value)) {
            this.validate('number');
        } else {
            this.unvalidate('number');
        }

        if (this.specialRegex.test(value)) {
            this.validate('special');
        } else {
            this.unvalidate('special');
        }
    }

    /**
     * Validate indicator
     * 
     * @param {string} indicator 
     * 
     * @return {void}
     */
    validate(indicator: string) : void {
        this.validationIndicators[indicator].classList.add('is-valid');
        this.validationIndicators[indicator].classList.remove('is-invalid');
    }

    /**
     * Unvalidate indicator
     * 
     * @param {string} indicator 
     * 
     * @return {void}
     */
    unvalidate(indicator: string) : void {
        this.validationIndicators[indicator].classList.remove('is-valid');
        this.validationIndicators[indicator].classList.add('is-invalid');
    }
}
